import {
  INICIA_CURSO,
  SALVA_CURSO,
  REMOVE_CURSO,
  NOVO_CURSO,
  BUSCA_CURSO_EDICAO,
  INICIO_CURSO_SUCESSO,
  SALVA_CURSO_SUCESSO,
  REMOVE_CURSO_SUCESSO,
  BUSCA_CURSO_EDICAO_SUCESSO,
  ATUALIZA_CURSO,
  ON_SHOW_LOADER,
  ON_SHOW_SUCCESS_MESSAGE,
  SHOW_MESSAGE,
  HIDE_MESSAGE,
  LISTA_CURSO,
  LISTA_CURSO_SUCESSO,
  LIMPAR_CURSO,
  LISTA_ANOS_LETIVOS_POR_CURSO,
  LISTA_ANOS_LETIVOS_POR_CURSO_SUCESSO,
  LISTA_ESCOLAS_CURSO,
  LISTA_ESCOLAS_CURSO_SUCESSO,
  LISTA_ANOS_LETIVOS_POR_ESCOLA_CURSO,
  LISTA_ANOS_LETIVOS_POR_ESCOLA_CURSO_SUCESSO,
  APLICA_FILTRO_CURSO
} from 'constants/ActionTypes';

/*#############################################################################################*/
/* ------------------------------ Actions Fundamentais CRUD -----------------------------------*/

export const iniciaCurso = () => {
  return {
    type: INICIA_CURSO
  };
};

export const salvaCurso = (curso) => {
  return {
    type: SALVA_CURSO,
    payload: curso
  };
};

// Opcional: ação explícita para atualizar curso (se quisermos separar do SALVA)
export const atualizaCurso = (curso) => {
  return {
    type: ATUALIZA_CURSO,
    payload: curso
  };
};

export const removeCurso = (id) => {
  return {
    type: REMOVE_CURSO,
    payload: id
  };
};

export const listaCurso = (filtros) => {
  const payload = typeof filtros === 'string' ? { nome: filtros } : (filtros || {});

  return {
    type: LISTA_CURSO,
    payload
  };
};

export const listaAnosLetivosPorCurso = (id) => {
  return {
    type: LISTA_ANOS_LETIVOS_POR_CURSO,
    payload: id
  };
};


/*#############################################################################################*/
/* ---------------------------- Actions do Fluxo de Navegação ---------------------------------*/

export const novoCurso = () => {
  return {
    type: NOVO_CURSO
  };
};

export const buscaCursoEdicao = (id) => {
  return {
    type: BUSCA_CURSO_EDICAO,
    payload: id
  };
};

/*#############################################################################################*/
/* --------------------------- Actions de respostas actions anteriores ------------------------*/  

export const inicioCursoSucesso = (curso) => {
  return {
    type: INICIO_CURSO_SUCESSO,
    payload: curso
  }
};

export const onChangeFilterCurso = (e) => {
  return {
      type: APLICA_FILTRO_CURSO,
      payload: e.target.value
  }
};

export const salvaCursoSucesso = (mensagem) => {
  return {
    type: SALVA_CURSO_SUCESSO,
    payload: mensagem
  }
};

export const removeCursoSucesso = (mensagem) => {
  return {
    type: REMOVE_CURSO_SUCESSO,
    payload: mensagem
  }
};  

export const buscaCursoEdicaoSucesso = (curso) => {
  return {
    type: BUSCA_CURSO_EDICAO_SUCESSO,
    payload: curso
  };
}; 

export const listaCursoSucesso = (curso) => {
  return {
    type: LISTA_CURSO_SUCESSO,
    payload: { curso }
  };
};

export const listaAnosLetivosPorCursoSucesso = (lista) => {
  return {
    type: LISTA_ANOS_LETIVOS_POR_CURSO_SUCESSO,
    payload: lista
  };
};

export const listaEscolasCurso = () => ({ type: LISTA_ESCOLAS_CURSO });
export const listaEscolasCursoSucesso = (escolas) => ({ type: LISTA_ESCOLAS_CURSO_SUCESSO, payload: escolas });

export const listaAnosLetivosPorEscolaCurso = (escolaId) => ({ type: LISTA_ANOS_LETIVOS_POR_ESCOLA_CURSO, payload: escolaId });
export const listaAnosLetivosPorEscolaCursoSucesso = (anos) => ({ type: LISTA_ANOS_LETIVOS_POR_ESCOLA_CURSO_SUCESSO, payload: anos });

export const limparFiltroCurso = () => {
  return {
    type: LIMPAR_CURSO,
  };
};

/*#############################################################################################*/
/* ---------------------------------- Outras Actions Auxiliares -------------------------------*/ 

export const exibirMensagemErro = (message) => {
  return {
    type: SHOW_MESSAGE,
    payload: message
  };
};

export const showAuthLoader = () => {
  return {
    type: ON_SHOW_LOADER,
  };
};

export const hideMessage = () => {
  return {
    type: HIDE_MESSAGE,
  };
};

export const showAuthMessage = (message) => {
  return {
    type: SHOW_MESSAGE,
    payload: message
  };
};

export const showSuccessMessage = (message) => {
  return {
    type: ON_SHOW_SUCCESS_MESSAGE,
    payload: message
  };
};